<template>
  <div ref="editorCnt" class="editorCnt">
    <ListHandler v-if="editor" :editor="editor" :onChange="triggerChange"/>
    <MediaHandler v-if="editor" :editor="editor" :editorCnt="$refs.editorCnt"
      :content="content" v-on:changed="$emit('input')"/>
    <div :class="{editor: true, editorSmall: size == 'small',
      hasContent: (content && content != '')}"
      v-html="content" ref="editor"
      v-on:blur="$emit('blur')"
      v-on:keydown.enter="$emit('enter')"
      v-on:keydown.delete="$emit('delete')">
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import MediumEditor from 'medium-editor';
import ListHandler from './ListHandler.vue';
import MediaHandler from './MediaHandler.vue';

export default {
  name: 'editor',
  data() {
    return {
      editor: null,
      defaultOptions: {
        forcePlainText: true,
        placeholder: {
          text: 'Write something great!!',
          hideOnClick: false,
        },
        imageDragging: false,
        autoLink: true,
        targetBlank: true,
        toolbar: {
          buttons: ['bold', 'italic', 'quote', 'anchor', 'h2', 'h3', 'orderedlist'],
        },
      },
    };
  },
  props: ['options', 'onChange', 'content', 'height', 'size', 'autofocus'],
  computed: {
    editorOptions() {
      return { ...this.defaultOptions, ...this.options };
    },
  },
  components: {
    ListHandler, MediaHandler,
  },
  mounted() {
    this.createElm();
    if (this.autofocus) {
      this.$refs.editor.focus();
    }
    if (this.height) {
      this.$refs.editor.style.minHeight = this.height;
    }
  },
  methods: {
    createElm() {
      this.editor = new MediumEditor(this.$refs.editor, this.editorOptions);
      this.editor.subscribe('editableInput', this.triggerChange);
    },
    destroyElm() {
      this.editor.destroy();
    },
    triggerChange() {
      const content = this.editor.getContent();
      this.$emit('input', content);
    },
  },
  destroyed() {
    this.destroyElm();
  },
};
</script>

<style lang="scss">
  .editorCnt{
    .editor{
      p{
        margin: 0;
      }
      blockquote{
        font-size: 26px;
        line-height: 1.3;
        // border-left: #ddd 4px solid;
        position: relative;
        margin: 26px 0;
        padding-bottom: 6px;
        color: #767676;
        padding-left: 50px;
        // padding-left: 30px;
        &:before{
          content: "\"";
          font-size: 80px;
          position: absolute;
          left: 8px; top: -18px;
        }
      }
      p.caption{
        margin: -14px 0 20px 10px;
        font-size: 15px;
        line-height: 1.4;
        min-height: 22px;
      }
    }
  }
</style>

<style scoped lang="scss">
  // @import "~bulma/css/bulma.css";
  @import "~medium-editor/dist/css/medium-editor.css";
  @import "~vuejs-medium-editor/src/themes/default.css";

  .editorCnt{
    display: block;
    position: relative;
    z-index: 1;
    .editor{
      outline: 0 !important;
      font-size: 20px;
      color: #444;
      padding: 10px 0;
      width: 100%;
      box-sizing: border-box;
      margin: 0;
      line-height: 1.6;
      min-height: 400px;
    }
    .editor:focus{
      border-color: #0747a6;
    }
    .editor:after{
      // font-style: normal;
      color: #767676;
      cursor: text;
    }
    .editorSmall{
      font-size: 16px;
      margin-bottom: 10px;
      padding: 8px 12px;
    }
  }
</style>
